import React, { Component, Fragment } from 'react';
import ReactGA from 'react-ga';
import {Helmet} from "react-helmet";
import NavTop from '../../containers/NavTop/NavTop';
import Link from 'react-router-dom/Link';
import ContactSection from '../../containers/ContactSection/ContactSection';
import VirusCard from '../../common/Cards/VirusCard/VirusCard';
import './VirusPage.css';
import { BackTop, Divider, Button, Icon, Row, Col } from 'antd';


class Virus extends Component {

  constructor(props){
    super(props);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }


  render(){ 
    return (
      <Fragment>
        <Helmet>
            <meta charSet="utf-8" />
            <title>RealTimeTouch.com - COVID-19 Virus page</title>
            <link rel="canonical" href="http://www.realtimetouch.com/faq/" />
        </Helmet>
        <NavTop pageOn={this.props.pageOn}/>
        <BackTop />
        <div className="RemoteRx--subnavbar-container mobileoff" style={{backgroundColor:"red", height:60, position:'relative', top:"-4px"}}>
          <div className="RemoteRx--subnavbar center mobileoff">
          </div>  
          <div className="RemoteRx--subnavbar2 center mobileoff">
          </div>
          <h2 className="RemoteRx--subnavbar-headline mobileoff font-special-heading" style={{color:"white"}}>
            {/* <img src="https://www.realtimetouch.com/images/remoterx/PDF_32.png" alt="PDF" style={{marginRight: 4}} /> */}
            COVID-19 - Coronavirus Pandemic - Telemedicine Outlook</h2>
        </div>
          <div className="RemoteRx--container center">

            <div className="RemoteRx--headline-container" style={{position:'relative', top:"-20px"}}>
              <h2 className="RemoteRx--subheadline">Exploring COVID-19 Virus Telemedicine Solutions<br />from the First Remote Caregiver-controlled Rx Home Dispenser</h2>
              <h4 className="RemoteRx--body">Millions of Medical Providers and Patients will be using Telehealth solutions.</h4> 
              <h4 className="RemoteRx--body">
                Real Time Touch can help develop these solutions with key intellectual property rights and visionary designs. 
              </h4> 
              {/* <h4 className="RemoteRx--body">
              Join with us in this exciting new Distributed Health human and environmental friendly development.
              </h4> */}
              {/* <h5 style={{marginTop:10}}>View some of the Frequently Asked Questions about Real Time Touch below!<br />(Click question for the answer)</h5> */}
   
              
            </div>

            
 
            <div style={{paddingBottom:20}}>
              {/* <img className="RemoteRx--img" alt="Solve the $300 Billion Problem" src="https://www.realtimetouch.com/images/remoterx/solve-problem.png" /> */}
            </div>
            {/* <div style={{paddingBottom:40, width:400, margin:'0 auto'}}>
              <h5>Studies estimate medication nonadherence, nonoptimized medication therapy and resulting hospitalizations <b>may cost $300+ billion in the US alone and even more worldwide</b>. </h5>
            </div>             */}
            <div style={{paddingBottom:10}}>
              <img className="RemoteRx--img" alt="Coronavirus Earth" src="https://www.realtimetouch.com/images/remoterx/corona-4965356_800.jpg" />
            </div>

            <Divider style={{width:'50%', margin:'20px auto'}}/>   


  <h1>
  <u>Real Time Touch</u>: <br />Addressing the COVID-19 Pandemic<br />and other Infectious Disease Outbreaks
  </h1>
  <h4>
    The COVID-19 pandemic has led to a surge in telehealth usage and applications that coincides with Real Time Touch's telemedicine-related technology patent and strategic digital health initiatives. 
  </h4>
  <h2>
    Real Time Touch is currently seeking collaboration and partners for R&D and for future applications to resolve crisis' like the current pandemic.
  </h2>
  <p>note: Real Time Touch technology is currently in R&amp;D and not commercially sold or available for purchase</p>

  <h5>

  According to the U.S. Government Centers for Medicare & Medicaid Services:  
  </h5>
  <p>
    source: MEDICARE TELEMEDICINE HEALTH CARE PROVIDER FACT SHEET (Mar 17, 2020 )<br />
    https://www.cms.gov/index.php/newsroom/fact-sheets/medicare-telemedicine-health-care-provider-fact-sheet
  </p>


  <div style={{paddingBottom:10}}>
    <img className="RemoteRx--img" alt="White House" src="https://www.realtimetouch.com/images/remoterx/the-white-house-1623005_590.jpg" />
  </div>

  
  
  <h3>"Under President Trump's leadership, the Centers for Medicare & Medicaid Services (CMS) has broadened access to Medicare <u>telehealth services</u> so that beneficiaries can receive a wider range of services from their doctors without having to travel to a healthcare facility. "
    
  </h3>
  
  <h5>

  The report continues (excerpts of several points throughout the report, see the full report linked in source below for all details): "There are three main types of virtual services physicians and other professionals can provide to Medicare beneficiaries summarized in this fact sheet:  Medicare telehealth visits, virtual check-ins and e-visits. "
  </h5>
  

  {/* https://www.realtimetouch.com/images/remoterx/corona-4983564_133.jpg */}

  <Row style={{margin:"20px 0"}}>
      <Col span={6}>
       <img className="img-rounded" alt="Remote Rx Dispenser and Telemedicine Platform" src="https://www.realtimetouch.com/images/remoterx/woman-2821623_130.jpg" />
      </Col>
      <Col span={18}>  
        <h4 style={{textAlign:"left"}}>
          1. <b><u>MEDICARE TELEHEALTH VISITS</u></b>: "The provider must use an interactive audio and video telecommunications system that permits real-time communication between the distant site and the patient at home."</h4>        
    </Col>
  </Row>

  <Row style={{margin:"30px 0"}}>
      <Col span={4}></Col>
      <Col span={16}>  
        <p style={{textAlign:"center"}}>
        <hr style={{ width:"50%", margin:"20px auto" }} />
        "It is imperative during this public health emergency that patients avoid travel, when possible, to physicians' offices, clinics, hospitals, or other health care facilities where they could risk their own or others' exposure to further illness"
        <hr style={{ width:"50%", margin:"20px auto" }} />
        </p>
    </Col>
    <Col span={4}></Col>
  </Row>
  

    
  <Row style={{margin:"20px 0"}}>
  <Col span={6}>
       <img className="img-rounded" alt="Remote Rx Dispenser and Telemedicine Platform" src="https://www.realtimetouch.com/images/remoterx/eye-130.jpg" />
      </Col>
      <Col span={18}>  
        <h4 style={{textAlign:"left"}}>
        2. <b><u>VIRTUAL CHECK-INS</u></b>: "In all areas (not just rural), established Medicare patients in their home may have a brief communication service with practitioners via a number of communication technology modalities including synchronous discussion over a telephone or exchange of information through video or image Medicare pays for these 'virtual check-ins' (or Brief communication technology-based service) for patients to communicate with their doctors and avoid unnecessary trips to the doctor's office... 
        </h4>
    </Col>
  </Row>

  <Row style={{margin:"30px 0"}}>
      <Col span={4}></Col>
      <Col span={16}>  
        <p style={{textAlign:"center"}}>
        <hr style={{ width:"50%", margin:"20px auto" }} />
        "Virtual check-ins can be conducted with a broader range of communication methods, unlike Medicare telehealth visits, which require audio and visual capabilities for real-time communication."
        <hr style={{ width:"50%", margin:"20px auto" }} />
        </p>
    </Col>
    <Col span={4}></Col>
  </Row>
  
  <Row style={{margin:"20px 0"}}>
  <Col span={6}>
       <img className="img-rounded" alt="Remote Rx Dispenser and Telemedicine Platform" src="https://www.realtimetouch.com/images/remoterx/x-ray-of-the-jaw-130.jpg" />
      </Col>
      <Col span={18}>  
        <h4 style={{textAlign:"left"}}>
        3. <b><u>E-VISITS</u></b>: "In all types of locations including the patient’s home, and in all areas (not just rural), established Medicare patients may have non-face-to-face patient-initiated communications with their doctors without going to the doctor’s office by using online patient portals."
        </h4>
    </Col>
  </Row>

  <Row style={{margin:"30px 0"}}>
      <Col span={4}></Col>
      <Col span={16}>  
        <p style={{textAlign:"center"}}>
        <hr style={{ width:"50%", margin:"20px auto" }} />
        "Effective immediately, the HHS Office for Civil Rights (OCR) will exercise enforcement discretion and waive penalties for HIPAA violations against health care providers that serve patients in good faith through everyday communications technologies, such as FaceTime or Skype, during the COVID-19 nationwide public health emergency."
        <hr style={{ width:"50%", margin:"20px auto" }} />
        </p>
    </Col>
    <Col span={4}></Col>
  </Row>


  <Divider style={{width:'50%', margin:'20px auto'}}/>    
  
  <h2>

  Prominent mention of "<u>real time</u>" telemedicine solutions.
  </h2>
  
  <Divider style={{width:'50%', margin:'20px auto'}}/>    

  
  <h4>

  Real Time Touch's visionary founder and inventor <a href ="https://www.linkedin.com/in/craig-linden-a093595">Craig Linden</a> has put forth real-time telemedicine solutions for years.<br />Real Time Touch is looking for partners to bring this vision to a mass audience and promote global wellness.
  </h4>
  
  <Divider style={{width:'50%', margin:'20px auto'}}/>    

  <h3>

  Real Time Touch's technology platform consists of 2 main parts which are rooted in the foundation of Craig Linden's patent "Powered physical displays on mobile devices" (US Patent 9,639,150). </h3>
  <p>note: Real Time Touch technology is currently in R&amp;D and not commercially sold or available for purchase</p>
  
  <Divider style={{width:'50%', margin:'20px auto'}}/>  
  <div style={{textAlign:"left"}}>
    <h4>1. Real Time Touch Medication Dispenser device: a cloud-connected medication dispenser with advanced capabilities.</h4>
    <h4>2. Real Time Touch Telemedicine Communications Platform device: an app which can be used on a variety of input and display devices to control the telemedicine and dispenser platform</h4>
  </div>
  
  <Divider style={{width:'50%', margin:'20px auto'}}/>    
  
  <div style={{paddingBottom:10}}>
    <img className="RemoteRx--img" alt="Real Time Touch" src="  https://www.realtimetouch.com/images/remoterx/dispenser-phone-text2.jpg" />
  </div>

  <Divider style={{width:'50%', margin:'20px auto'}}/>   

<div style={{width:'100%'}}>
  <h3>Read More in our full brochure... </h3>
  <Link to="/contactremoterx/">
    <Button size="large" type="primary" style={{backgroundColor:"red"}}>
    <img src="https://www.realtimetouch.com/images/remoterx/PDF_32.png" alt="PDF" style={{marginRight: 4}} />Get the Full Brochure<Icon type="caret-right" /></Button>
  </Link>
</div>

<Divider style={{width:'50%', margin:'20px auto'}}/> 
  
  <h4>

  We've compiled a list of telehealth solutions that could potentially leverage Real Time Touch ideas and/or patented technology concepts to help address the current COVID-19 pandemic and other potentially dangerous viruses and infection outbreaks.

  </h4>


  <h3>Real Time Touch and Telemedicine Potential Applications for Use in Covid-19 Pandemic and other Infectious Outbreaks</h3>

  <h4>1. Virtual Face-to-Face Communication with Healthcare providers.</h4>

<h5>According to sources quoted by MobihealthNews, virtual visits have been up tremendously as the pandemic as increased: "Cleveland Clinic's telehealth calls had a 15-fold increase over the last week." said one digital health executive... "'We are doing more virtual visits in a given day than we did the entire proceeding year, so things can change,' John Brownstein, Chief Innovation Officer at Boston Children's Hospital" - How telemedicine is being used on the frontlines of the coronavirus crisis</h5>

<h5>Real Time Touch envisions our Communication Platform technology concept as described in patent designs  having at the root a video teleconferencing capability with gesture recognition and physical touch simulation capabilities.</h5>

<ul style={{textAlign:"left"}}>
    <li> Virtual doctor, nurse and healthcare provider visits with audio and video and chat functions in real-time.</li>
    <li> AI coaching, Siri and Alexa-like voice activation and voice/gesture recognition could enhance the RTT communications experience.</li>
    <li> It's envisioned that RTT's solution could include a physical display apparatus to convert energy into physical movement, which would add the 4th dimension to current virtual visits.</li>
    <li> Face-to-face real time communications results and sensor data could easily be checked and sent during the virtual visit.</li>
</ul>


    <h4>2. Remote Diagnostic and Monitoring of patients in Quarantine</h4>

<h5>People could be tested for Covid-19 and/or Covid-19 positive patients with mild symptoms can do testing and stay in touch with healthcare providers.</h5>

<ul style={{textAlign:"left"}}>

    <li>Home Covid-19 testing kits if allowed - Note: the FDA has not currently approved or allowed Covid-19 home testing kits, however this could be a possibility in the future if FDA rules change (see source below). Real Time Touch would like to collaborate with manufacturers to integrate into our envisioned telehealth platform. Lab-in-a-box test can detect COVID-19 in 5 minutes according to a new report by Endgadget (source below)</li>

    <li>Respiratory-related sensors such as oxygen % monitoring, heart rate and blood pressure. This could be transmitted to healthcare providers on a periodic basis and seamlessly integrated in other alerts and statistics data used for disease surveillance.</li>
    
    <li>Sensor, dosage results and other data can be tracked, communicated and analyzed remotely for alerts, efficacy, and improving health outcomes.</li>
    
    <li>Our Communications Platform and Dispenser would have eHealth tool extensibility: 3rd-party APIs and tools (hardware and software) can be activated. </li>
</ul>

    <h4>3. Real Time Monitoring with Wearable Electronics and Sensors</h4>

<h5>There are a number of examples of wearable-related technologies being used to test and track Covid-19 symptoms.</h5>

    Comparing wearable-detected diagnostics and known virus symptoms could result in faster disease diagnosis and outbreaks.
    Wearable devices like the Apple Watch or Fitbit could be used to sync to a Real Time Touch base station, for a complete telehealth virtual visit with medical healthcare providers.

Real Time Touch is not involved in the new studies below, however, we believe our patented technology ideas could be utilized in similar ways given additional R&D funding strategic initiatives and production capacity.

Examples:

<ul style={{textAlign:"left"}}>
    <li>Scripps Research Detect: "Your wearable might be an early warning system for viral illness" ... " At Scripps Research, we’ve designed DETECT (Digital Engagement & Tracking for Early Control & Treatment), a study that will monitor your heart rate and allow you to record symptoms like fever or coughing. "</li>
    
    <li> UCSF TemPredict stidy #1 - "more than 2,000 healthcare workers — doctors, nurses, and others — who are in daily contact with patients who may be afflicted with COVID-19 at UCSF campuses will receive Oura rings. By letting healthcare workers easily track changes in their body temperature, respiratory rate, and heart rate, they may be better equipped to understand early warning signs of infection within the group and to take necessary actions to better coordinate this unprecedented push to fight COVID-19."</li>
    
    <li>UCSF TemPredict stidy #2 - for "all Oura ring users. By taking daily symptom surveys, study participants will directly contribute their observations paired to their data to the UCSF team. Researchers will use this information as they attempt to identify patterns that could predict onset, progression, and recovery in future cases of COVID-19"</li>

    </ul>
    <h4>4. Virtual Reality with Virtual Touch Technologies</h4>

    <ul style={{textAlign:"left"}}>
    <li>Teleradiology radiographic images (X-rays, CT, MR, PET/CT)</li>
    <li>Injury X-rays & other radiological images could be quickly transmitted from the field to medical professionals for inexpensive and rapid analysis. Telemedicine is ready to be delivered to diverse places throughout the world on a moment's notice.</li>
<li>Remote Physical Therapy in Real-time.</li>
<li>Physical Therapists could verify physical therapy proceeding properly. Real Time Touch can help facilitiate this</li>
<li>Vital Signs, temperature , cardio/pulmonary & sensor data.</li>
<li>A variety of patient vital signs can be measured and recorded for use by medical professionals.
Real-time Blood analysis.</li>
<li>A Real Time Touch unit could include blood analysis with checmical composition and patient results being quickly transmitted in real time to qualified professionals for analysis.
</li>  

</ul>

<h4>5. Online mental health support from the home with telepsychology and other mental telehealth therapies.</h4>

<h5>As of late March 2020 there were approximately 2.6 billion – one-third of the human population, (Agence France-Presse). </h5>

<h5>"Online mental health support is increasingly important as communities face lockdown and social distancing measures"</h5>
<ul style={{textAlign:"left"}}>
<li>Virtual mental health programs with privacy, convenience and avoidance of unnecessary </li>
<li>Seniors and/or those quarantines, or infirmed with Covid-19 can be both socially-connected and independent.</li>
<li>Meditation and mindfulness content
    mindfulness-based cognitive therapy (MCBT)</li>
    <li>Substance abuse treatment
    connecting psychologists and psychiatrists with patients</li>
    <li>Mental health professionals can maintain their practice without risk of infectious contact to themselves and staff</li>
</ul>

    <Divider style={{width:'50%', margin:'20px auto'}}/>    
  
  <div style={{paddingBottom:10}}>
    <img className="RemoteRx--img" alt="Real Time Touch" src="  https://www.realtimetouch.com/images/remoterx/dispenser-phone-text2.jpg" />
  </div>

  <Divider style={{width:'50%', margin:'20px auto'}}/>   

<div style={{width:'100%'}}>
  <h3>Read More in our full brochure... </h3>
  <Link to="/contactremoterx/">
    <Button size="large" type="primary" style={{backgroundColor:"red"}}>
    <img src="https://www.realtimetouch.com/images/remoterx/PDF_32.png" alt="PDF" style={{marginRight: 4}} />Get the Full Brochure<Icon type="caret-right" /></Button>
  </Link>
</div>

<p>note: Real Time Touch technology is currently in R&amp;D and not commercially sold or available for purchase</p>

<h4>Sources:</h4>

    <p>MEDICARE TELEMEDICINE HEALTH CARE PROVIDER FACT SHEET - https://www.cms.gov/newsroom/fact-sheets/medicare-telemedicine-health-care-provider-fact-sheet</p>

    <p>"34.3 million American adults self-reported needing treatment for alcohol or illicit drug use, " https://www.samhsa.gov/prevention</p>
    
    <p>"a four-year Johns Hopkins study that included close to 100,000 veterans found the number of days patients were hospitalized dropped by 25 percent if they chose online counseling " https://www.healthitoutcomes.com/doc/the-role-of-telemedicine-in-mental-health-0001</p>
    
    <p>Scripps, UCSF kick off wearable-driven research projects to spot viral infections early on https://www.mobihealthnews.com/news/scripps-ucsf-kick-wearable-driven-research-projects-spot-viral-infections-early</p>
    
    <p>DETECT: https://detectstudy.org/</p>
    
    <p>UCSF Oura ring studies: https://ouraring.com/ucsf-tempredict-study</p>
    
    More People Are Now in 'Lockdown' Than Were Alive During World War II - https://www.sciencealert.com/one-third-of-the-world-s-population-are-now-restricted-in-where-they-can-go
    
    " The Food and Drug Administration (FDA) has released today a list of approved COVID-19 test kits for commercial use.  These are PCR based reagent kits used in laboratories and not point-of-care or do-it-yourself kits." - https://www.fda.gov.ph/list-of-fda-approved-covid-19-test-kits-for-commercial-use/
    
    How telemedicine is being used on the frontlines of the coronavirus crisis  https://www.mobihealthnews.com/news/how-telemedicine-being-used-frontlines-coronavirus-crisis
    
    "Lab-in-a-box test can detect COVID-19 in 5 minutes The FDA has cleared the device for use during the pandemic". https://www.engadget.com/2020-03-28-abbott-covid-19-lab-in-box-test-fda.html
    COVID-19 home-testing kit could soon be available for purchase in UK https://www.mobihealthnews.com/news/europe/covid-19-home-testing-kit-could-soon-be-available-purchase-uk
    NHS pilots home testing for coronavirus https://www.mobihealthnews.com/news/europe/nhs-pilots-home-testing-coronavirus


            
            <div style={{width:'100%'}}>
                <h3>Read More in our full brochure... </h3>
                <Link to="/contactremoterx/">
                  <Button size="large" type="primary">
                    <img src="https://www.realtimetouch.com/images/remoterx/PDF_32.png" style={{marginRight: 4}} alt="PDF" />Get the Full Brochure<Icon type="caret-right" /></Button>
                </Link>
              </div>

             <Divider style={{width:'50%', margin:'20px auto'}}/>    

            <div class="RemoteRx--body-list">


            <p>note: Real Time Touch technology is currently in R&amp;D and not commercially sold or available for purchase</p>



              <h3>Big Problems to Solve, Potential to Save Billions</h3>
              <p style={{fontSize: '1.2em'}}>
              Lack of Medication Adherence is estimated to be costing <u>$300 billion+</u> (in the U.S. alone!) in increased burden to the medical system due to:
              </p>
              <ul>
                <li> Patients not taking medications as prescribed.</li> 
                <li> Missed doses due to scheduling confusion.</li> 
                <li> Emergency room visits due to avoidable errors.</li> 
                <li> Misunderstood dosages reducing efficacy.</li> 
                <li> Inconvenience of adhering to scheduled doses.</li> 
                <li> Medical advice requires waiting & travel. </li> 
                <li> Drug dependency & abuse of opioids and other drugs. </li> 
                <li> Medical providers not be aware of missed doses.</li>
              </ul>

              
            <Divider style={{width:'50%', margin:'20px auto'}}/>   

                <h3>We're developing solutions that can:</h3>
                <ul>
                  <li> Save money for patients, caregivers, hospitals, insurance and government</li> 
                  <li> Promote better health and lives for seniors and those in need who rely on medication.</li> 
                  <li> Help Seniors to stay both socially-connected and independent while getting the treatments they need.</li> 
                </ul>

            </div>
            

            <Divider style={{width:'50%', margin:'20px auto'}}/>   

            <div style={{width:'100%'}}>
              <h3>Read More in our full brochure... </h3>
              <Link to="/contactremoterx/">
                  <Button size="large" type="primary">
                    <img src="https://www.realtimetouch.com/images/remoterx/PDF_32.png" alt="PDF" style={{marginRight: 4}} />Get the Full Brochure<Icon type="caret-right" /></Button>
                </Link>
            </div>

            <Divider style={{width:'50%', margin:'20px auto'}}/>   

            <div class="RemoteRx--body-list">
              <h3>How Real Time Touch Helps Solve the Problem</h3>
              <h4>Real Time Touch Remote Rx Dispenser Features</h4>
              <p style={{fontSize: '1.2em'}}>
              Real Time Touch telemedicine platform Rx Dispenser planned features include:
              </p>

            <div style={{padding:20}}>
              <img className="RemoteRx--img img-rounded" alt="Remote Rx with Doctor" src="https://www.realtimetouch.com/images/remoterx/dispenser-phone-dr.jpg" />
            </div>


              <ul>
                <li> <b>Automatic timed release</b> with sound/light/voice reminders and 
alarms to 3rd parties when pills not taken.</li> 
                <li>Can be integrated seamlessly with other platforms that <b>monitor vitals, activity and sleep.</b></li>
                <li> <b>Security Levels</b> (multiple) for patient, medical providers and caregivers 
allowing remote locking/unlocking by user role.</li> 
                <li> Use with various interface devices (smartphone, tablet, PC or TV) -- or manually without remote from the dispenser interface</li> 
                <li> <b>AI coaching, Alexa-like voice activation</b> and voice/gesture recognition.</li> 
                <li> <b>Sensor, dosage results</b> and other data can be tracked, communicated
 and analyzed remotely for alerts, efficacy, and improving health outcomes.</li> 
                <li> eHealth tool extensibility: <b>3rd-party APIs and tools</b> (hardware and software) can be activated. </li> 
                <li> Prevents re-admissions by <b>alerting Medical providers</b> of problems.</li> 
                <li> Seniors can be both socially-connected and independent.</li>
              </ul>

            

            </div>

            <Divider style={{width:'50%', margin:'20px auto'}}/>   

              <div style={{width:'100%'}}>
                <h3>Read More in our full brochure... </h3>
                <Link to="/contactremoterx/">
                  <Button size="large" type="primary">
                  <img src="https://www.realtimetouch.com/images/remoterx/PDF_32.png" alt="PDF" style={{marginRight: 4}} />Get the Full Brochure<Icon type="caret-right" /></Button>
                </Link>
              </div>
            
            <Divider style={{width:'50%', margin:'20px auto'}}/> 

            <div style={{padding:20}}>
              <img className="RemoteRx--img" alt="Remote Rx Dispenser and Telemedicine Platform" src="https://www.realtimetouch.com/images/remoterx/dispenser-phone-text2.jpg" />
            </div>

            <div class="RemoteRx--disclaimer">
            <p>Disclaimer: This informational document is to get feedback on future business/product ideas, not a solicitation for 
investment and should not be relied on for investment purposes. Scenarios, financial & technology projections & product features 
discussed are speculative, and may not occur. Statistics cited are estimates that may be unverified from 3rd-parties. Results,
revenues, costs are not guaranteed & subject to substantial change/risks. Patents may expire before licensing. Pending patent
applications may not be granted. Success is contingent on further investments, product development, licensing and/or partnerships.</p>
           
            </div>

            {/* <ContactSection background="none"/> */}

          </div>
        </Fragment>
    )
  }
}
 
 
 export default Virus;


// WEBPACK FOOTER //
// ./src/pages/VirusPage/VirusPage.js